export default {
  ADMIN: 'admin',

  XEM: 'xem',

  /** Phòng QLTM */
  P_QLTM: 'pQltm',

  // Thương nhân
  THUONG_NHAN: 'thuongNhan',

  // Xăng dầu
  QL_XANG_DAU: 'qlXangDau',
  DM_DAI_LY_XD: 'dmDaiLyXd',
  DM_CO_QUAN_CHU_QUAN: 'dmCoQuanChuQuan',
  BC_CUA_HANG_XANG_DAU: 'bcCuaHangXangDau',

  // Thuốc lá
  QL_THUOC_LA: 'qlThuocLa',
  DM_CO_SO_BAN_LE_THUOC_LA: 'dmCoSoBanLeThuocLa',
  DM_NHA_BAN_BUON: 'dmNhaBanBuon',
  BC_BAN_BUON_THUOC_LA: 'bcBanBuonThuocLa',
  TK_THUOC_LA: 'tkThuocLa',

  // Quản lý VSATTP
  QL_VSATTP: 'qlVsattp',
  DM_NGANH_NGHE_KD: 'dmNganhNgheKd',
  DM_CO_SO_VSATTP: 'dmCoSoVsattp',
  BC_ATTP: 'bcAttp',
  TK_CSVSATTP: 'tkCsvsattp',
  TK_TONG_HOP_CSVS_ATTP: 'tkTongHopCsvsAttp',

  // Rượu
  QL_RUOU: 'qlRuou',
  DM_CHUNG_LOAI_RUOU: 'dmChungLoaiRuou',
  BC_RUOU_TC: 'bcRuouTc',
  BC_RUOU_CONG_NGHIEP: 'bcRuouCongNghiep',
  BC_XS_KD_RUOU: 'bcXsKdRuou',

  // Chợ
  QL_CHO: 'qlCho',
  BC_CHO: 'bcCho',
  TK_PHAT_TRIEN_CHO: 'tkPhatTrienCho',

  // Gas
  QL_GAS: 'qlGas',
  BC_GAS: 'bcGas',
  TK_CUA_HANG_GAS: 'tkCuaHangGas',

  // Doanh nghiệp bán hàng đa cấp
  QL_DNBH_DA_CAP: 'qlDnbhDaCap',
  BC_DOANH_NGHIEP_DA_CAP: 'bcDoanhNghiepDaCap',
  TK_DOANH_NGHIEP_DA_CAP: 'tkDoanhNghiepDaCap',

  // Hội chợ
  QL_HOI_CHO: 'qlHoiCho',
  BC_HOI_CHO: 'bcHoiCho',
  TK_HOI_CHO: 'tkHoiCho',

  // Hợp đồng theo mẫu
  QL_HOP_DONG_THEO_MAU: 'qlHopDongTheoMau',
  BC_HOP_DONG_THEO_MAU: 'bcHopDongTheoMau',
  TK_DOANH_NGHIEP_DANG_KY_HOP_DONG_THUONG_MAI: 'tkDoanhNghiepDangKyHopDongThuongMai',

  // Đăng ký dấu
  QL_DANG_KY_DAU: 'qlDangKyDau',
  BC_DANG_KY_DAU: 'bcDangKyDau',
  TK_DANG_KY_DAU: 'tkDangKyDau',

  // Thuốc lá 2020
  QL_THUOC_LA_2020: 'qlThuocLa2020',
  DM_THUOC_LA_2020: 'dmThuocLa2020',
  DM_QUAN_LY_THUONG_NHAN_THUOC_LA: 'dmQuanLyThuongNhanThuocLa',
  BC_THUOC_LA_2020: 'bcThuocLa2020',
  BC_THUONG_NHAN_BAN_LE: 'bcThuongNhanBanLe',
  BC_THUONG_NHAN_DUOC_CAP_PHEP: 'bcThuongNhanDuocCapPhep',
  BC_TINH_HINH_KINH_DOANH: 'bcTinhHinhKinhDoanh',
  BC_DAU_TU_TRONG_CAY_THUOC_LA: 'bcDauTuTrongCayThuocLa',
  BC_THUONG_NHAN_BAN_BUON: 'bcThuongNhanBanBuon',
  BC_PHAN_PHOI_SAN_PHAM_THUOC_LA: 'bcPhanPhoiSanPhamThuocLa',
  BC_BAN_HANG_TAI_CAC_TINH_THANH_PHO: 'bcBanHangTaiCacTinhThanhPho',
  BC_BAN_HANG_TAI_CAC_DIEM_BAN_LE: 'bcBanHangTaiCacDiemBanLe',
  BC_TRONG_CAY_THUOC_LA: 'bcTrongCayThuocLa',

  // Rượu 2020
  QL_RUOU_2020: 'qlRuou2020',
  DM_RUOU_2020: 'dmRuou2020',
  DM_QUAN_LY_THUONG_NHAN_RUOU: 'dmQuanLyThuongNhanRuou',
  BC_RUOU_2020: 'bcRuou2020',
  BC_TINH_HINH_SAN_XUAT_RUOU: 'bcTinhHinhSanXuatRuou',
  BC_TINH_HINH_SAN_XUAT: 'bcTinhHinhSanXuat',
  BC_TINH_HINH_TIEU_THU: 'bcTinhHinhTieuThu',
  BC_PHAN_PHOI_RUOU_BAN_BUON: 'bcPhanPhoiRuouBanBuon',
  BC_TINH_HINH_MUA_VAO: 'bcTinhHinhMuaVao',
  BC_TINH_HINH_BAN_RA: 'bcTinhHinhBanRa',
  BC_BAN_LE_RUOU_TIEU_DUNG_TAI_CHO: 'bcBanLeRuouTieuDungTaiCho',
  BC_RUOU_THU_CONG: 'bcRuouThuCong',
  BC_SAN_XUAT_RUOU_BAN_CHO_DOANH_NGHIEP: 'bcSanXuatRuouBanChoDoanhNghiep',
  BC_SAN_XUAT_RUOU_KINH_DOANH: 'bcSanXuatRuouKinhDoanh',
  BC_BAN_LE_RUOU: 'bcBanLeRuou',
  BC_BAN_RUOU_TIEU_DUNG_TAI_CHO: 'bcBanRuouTieuDungTaiCho',
  BC_RUOU_TIEU_DUNG_TAI_CHO: 'bcRuouTieuDungTaiCho',
  BC_SAN_XUAT_RUOU: 'bcSanXuatRuou',
  BC_SAN_XUAT_RUOU_CONG_NGHIEP: 'bcSanXuatRuouCongNghiep',
  BC_TINH_HINH_KINH_DOANH_RUOU: 'bcTinhHinhKinhDoanhRuou',
  BC_RUOU_CO_DO_CON_DUOI_5_5: 'bcRuouCoDoConDuoi55',

  // Đăng ký khuyến mãi
  QL_DANG_KY_KHUYEN_MAI: 'qlDangKyKhuyenMai',
  BC_DANG_KY_KHUYEN_MAI: 'bcDangKyKhuyenMai',
  TK_DANG_KY_KHUYEN_MAI: 'tkDangKyKhuyenMai',

  // Biểu mẫu khác
  QL_BIEU_MAU_KHAC: 'qlBieuMauKhac',
  BC_TONG_MUC_BAN_LE_HANG_HOA: 'bcTongMucBanLeHangHoa',
  BC_TIEU_CHI_CSHTTM_NONG_THON: 'bcTieuChiCshttmNongThon',

  /** Phòng QLCN */
  P_QLCN: 'pQlcn',

  // Cụm CN - Dự án
  QL_CUM_CN_DA: 'qlCumCnDa',
  DM_CUM_CONG_NGHIEP: 'dmCumCongNghiep',
  BC_CO_SO_HA_TANG_THDT: 'bcCoSoHaTangThdt',
  DM_DU_AN: 'dmDuAn',
  BC_CUM_CONG_NGHIEP: 'bcCumCongNghiep',
  BC_DU_AN: 'bcDuAn',
  TK_THDT_KCHT: 'tkThdtKcht',
  TK_DU_AN: 'tkDuAn',
  QL_BM_CT: 'qlBmCt',

  // Thương mại điện tử
  QL_TMDT: 'qlTmdt',
  BC_THUONG_MAI_DIEN_TU: 'bcThuongMaiDienTu',
  TK_TMDT: 'tkTmdt',

  // Khuyến công
  QL_KHUYEN_CONG: 'qlKhuyenCong',
  BC_KHUYEN_CONG: 'bcKhuyenCong',
  KHUYEN_CONG_DIA_PHUONG: 'khuyenCongDiaPhuong',
  KHUYEN_CONG_UOC_TINH: 'khuyenCongUocTinh',
  BC_KET_QUA_HO_TRO: 'bcKetQuaHoTro',
  BC_UOC_TINH_THUC_HIEN: 'bcUocTinhThucHien',

  // Khu CN
  QL_KHU_CN: 'qlKhuCn',
  DM_KHU_CONG_NGHIEP: 'dmKhuCongNghiep',
  DM_KCN: 'dmKcn',
  BC_KHU_CONG_NGHIEP: 'bcKhuCongNghiep',
  TK_KHU_CONG_NGHIEP: 'tkKhuCongNghiep',
  DM_DU_AN_DAU_TU: 'dmDuAnDauTu',

  // Sản phẩm công nghiệp
  QL_SAN_PHAM_CN: 'qlSanPhamCn',
  BC_MOT_SO_SPCN_CHU_YEU: 'bcMotSoSpcnChuYeu',
  BC_CHI_SO_SAN_XUAT_CN: 'bcChiSoSanXuatCn',
  BC_KQ_BINH_CHON_SPCN_TIEU_BIEU: 'bcKqBinhChonSpcnTieuBieu',

  //Lĩnh vực khoáng sản
  QL_LINH_VUC_KHOANG_SAN: 'qlLinhVucKhoangSan',
  DM_LINH_VUC_KHOANG_SAN: 'dmLinhVucKhoangSan',

  /** Phòng KTATMT */
  P_KTATMT: 'pKtatmt',
  // Vật liệu nổ
  QL_VLN: 'qlVln',
  DM_QUAN_LY_DOANH_NGHIEP: 'dmQuanLyDoanhNghiep',
  DM_LOAI_HINH_HD: 'dmLoaiHinhHd',
  BC_VLN: 'bcVln',
  TK_GIAY_PHEP_VLNCN: 'tkGiayPhepVlncn',

  // Hóa chất
  QL_HOA_CHAT: 'qlHoaChat',
  DM_CO_SO_SU_DUNG_HOA_CHAT: 'dmCoSoSuDungHoaChat',
  LOAI_HOA_CHAT: 'loaiHoaChat',
  TINH_HINH_SU_CO_HOA_CHAT: 'tinhHinhSuCoHoaChat',
  BC_THANH_TRA_HC: 'bcThanhTraHc',
  TK_LOAI_HOA_CHAT: 'tkLoaiHoaChat',
  TK_TINH_HINH_SU_CO_HOA_CHAT: 'tkTinhHinhSuCoHoaChat',
  TK_THANH_TRA_HC: 'tkThanhTraHc',


  // công bố hợp quy
  QL_CONG_BO_HOP_QUY: 'qlCongBoHopQuy',
  DM_THEO_DOI_CONG_BO_HOP_QUY: 'dmTheoDoiCongBoHopQuy',

  /** Phòng QLNL */
  P_QLNL: 'pQlnl',

  QL_THUY_DIEN: 'qlThuyDien',
  DM_THUY_DIEN: 'dmThuyDien',
  BC_THUY_DIEN: 'bcThuyDien',
  QL_QUY_TRINH_VAN_HANH: 'qlQuyTrinhVanHanh',

  QL_TRAM_BA: 'qlTramBa',
  DM_TBA: 'dmTba',
  DM_TBA110: 'dmTba110',
  DM_TBA220: 'dmTba220',
  DM_TBA500: 'dmTba500',

  QL_CAP_DIEN: 'qlCapDien',
  BC_CAP_DIEN: 'bcCapDien',
  TK_CAP_DIEN: 'tkCapDien',

  QL_CAP_PHEP_HOAT_DONG_DIEN_LUC: 'qlCapPhepHoatDongDienLuc',
  DM_CAP_PHEP_HOAT_DONG_DIEN_LUC: 'dmCapPhepHoatDongDienLuc',
  QL_NL_TAI_TAO_VA_NANG_LUONG_KHAC: 'qlNlTaiTaoVaNangLuongKhac',
  DM_DU_AN_NL_TAI_TAO_VA_NANG_LUONG_KHAC: 'dmDuAnNlTaiTaoVaNangLuongKhac',
  KH_SU_DUNG_NL_TRONG_DIEM: 'khSuDungNlTrongDiem',
  DM_KH_SU_DUNG_NL_TRONG_DIEM: 'dmKhSuDungNlTrongDiem',

  /** Phòng quản lý thị trường */
  P_QLTT: 'pQltt',

  // Quản lý thị trường
  QL_THI_TRUONG: 'qlThiTruong',
  BC_CTQL_THI_TRUONG: 'bcCtqlThiTruong',

  /** Phòng đầu tư xuất nhập khẩu */
  P_QLDT: 'pQldt',

  // Quản lý xuất nhập khẩu
  QL_XUAT_NHAP_KHAU: 'qlXuatNhapKhau',
  BC_KIM_NGACH_XNK: 'bcKimNgachXnk',

  THANH_TRA: 'thanhTra'
};
